import type { ComponentProps } from "react";
import { RequiredCue, requiredLabelName } from "./RequiredMark";
import { Body1 } from "./Typography";
export function FieldLabel({
  label,
  required,
  color,
  "aria-hidden": ariaHidden
}: {
  label: string;
  required?: boolean;
  color?: ComponentProps<typeof Body1>["color"];
  "aria-hidden"?: boolean;
}) {
  return <Body1 color={color} aria-hidden={ariaHidden} aria-label={requiredLabelName(label, required)} data-sentry-element="Body1" data-sentry-component="FieldLabel" data-sentry-source-file="FieldLabel.tsx">
      {label}
      <RequiredCue required={required} data-sentry-element="RequiredCue" data-sentry-source-file="FieldLabel.tsx" />
    </Body1>;
}